import servicioBase from '@/services/servicio-base'

const servicio = {}

servicio.validarExistenciaArticulo =  (dato) => {
    return servicioBase.get(`/excel/validar-existencia-en-catalogo/${dato}`)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

export default servicio